<template>
  <WidgetPanel>
    <template #header>
      <div class="flex justify-between items-center">
        <h3 class="widget-headline">
          Coworker*innen ({{ podcast.num_memberships }})
        </h3>
        <button @click="invite">
          <PlusIcon class="flex-shrink-0 h-5 w-5 text-gray-400" />
        </button>
      </div>
    </template>
    <template #default>
      <div v-if="empty">
        <div class="block hover:bg-gray-50">
          <div class="min-w-0 flex-1 flex items-center">
            <div class="flex items-center px-4 py-4 sm:px-6">
              <div class="min-w-0 flex-1 flex items-center">
                <p class="text-sm font-medium text-gray-600 truncate">
                  Du hast aktuell keine Coworker*innen.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ul role="list" class="divide-y divide-gray-200">
        <CoworkerWidgetItem li v-for="m in results" :key="m.id" :membership="m" as="li" />
      </ul>
    </template>
  </WidgetPanel>
</template>

<script setup>
import { computed, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useFetchResources } from '@/client/actions';

const props = defineProps({podcast: Object});
const router = useRouter();

const parent = computed(() => props.podcast.id);
const target = computed(() => '/api/podcasts/' + parent.value + '/memberships');
const action = useFetchResources(target);

const { results, fetch, empty } = action;

const invite = () => router.push({name: 'podcasts.invite', params: {id: parent.value}});
const watcher = watch(target, (v, _) => fetch());
const mounted = onMounted(() => fetch());
</script>
